import {getReportParams, report} from '../../../middleware/report';

const dwhSelfCareSuspendActivateAccount = ({ actionType, status, messageText, param1 = '', param2 = '', param10 = '' ,idNumber = ''}) => {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'BusinessOpening/BlockingSubscription';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType = actionType;
  reportParams.status = status;
  reportParams.idNumber = idNumber;
  reportParams.messageText = messageText;
  reportParams.param1 = param1; // hethpey
  reportParams.param2 = param2; // sim num
  reportParams.param10 = param10; // phone number
  reportParams.businessDetails = {_subscriber: param10};
  report(reportParams);
};

export default dwhSelfCareSuspendActivateAccount;
